<template src="./TermsOfUse.html"/>
<style lang="scss" scoped src="./TermsOfUse.scss"/>

<script>

import {
  SfBreadcrumbs,
} from '@storefront-ui/vue';

export default {
  name: 'TermsOfUse',
  transition: 'fade',
  components: {

    SfBreadcrumbs
  },
  data() {
    return {
      locale: this.$i18n.locale,
      breadcrumbs: [
        {
          text: this.$i18n.t('Home'),
          link: '/'
        },
        {
          text: this.$i18n.t('Terms of sales'),
        }
      ]
    };
  },
};
</script>
